export default {
  title:
    'Category Leaders rankings showcase the top 15 apps within a category based on 5 key factors (reviews, mobile, security, integrations, and functionality).',
}
